<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<div mat-dialog-title>
  กรุณาใส่ Email
</div>

<mat-dialog-content class="mat-typography">
  <form [formGroup]="emailForm">
    <div class="form-group row mt-1">
      <label for="emailLogin" class="col-3 col-form-label">อีเมล</label>
      <input type="email" class="form-control col-9" formControlName="email" autocomplete="off">
    </div>
    <small class="row justify-content-center text-center text-danger">*ระบบไม่พบเจอ Email ของท่าน กรุณาใส่ Email</small>
    <div class="row justify-content-center">
      <div class="col-md-6 mb-2">
        <div *ngIf="this.errorMsg !== null">
          <span class="text-danger">{{errorMsg}}</span>
        </div>
        <lifedi-btn lable="ยืนยัน" *ngIf="!emailForm.valid" [disabled]="!emailForm.valid" customStyle="width: 100%;">
        </lifedi-btn>
        <lifedi-btn lable="ยืนยัน" *ngIf="emailForm.valid" (click)="confirm(emailForm.value)"
          customStyle="color:white; background-color: #414A6B; width: 100%;">
        </lifedi-btn>
      </div>
    </div>
  </form>
</mat-dialog-content>
